// src/constants/jewellery.constant.js

// Jewellery Module Route Constants
export const JEWELLERY_ROUTES = {
  // Base
  ROOT: "/jewellery",
  DASHBOARD: "/jewellery/dashboard",

  // Plan Management
  CREATE_PLAN: "/jewellery/new",
  PLAN_DETAILS: "/jewellery/:planId",
  ACTIVE_PLANS: "/jewellery/active",
  MATURED_PLANS: "/jewellery/matured",

  // Payments
  PAYMENTS: "/jewellery/payments",
  PAYMENT_VERIFICATION: "/jewellery/payments/verify",
  PAYMENT_RECORD: "/jewellery/payments/record/:planId",
  PAYMENT_DETAILS: "/jewellery/payments/:paymentId",
  PLAN_PAYMENT: "/jewellery/:planId/payment",

  // Redemptions
  REDEMPTIONS: "/jewellery/redemptions",
  REDEMPTION_DETAILS: "/jewellery/redemptions/:redemptionId",
  PLAN_REDEEM: "/jewellery/:planId/redeem",

  // Quotes
  CREATE_QUOTE: "/jewellery/redemptions/quote",
  PLAN_QUOTE: "/jewellery/:planId/quote",
  PLAN_CREATE_QUOTE: "/jewellery/:planId/create-quote",
  PLAN_QUOTES: "/jewellery/:planId/quotes",
  QUOTE_DETAILS: "/jewellery/:planId/quote/:quoteId",

  // Admin
  TEMPLATES: "/jewellery/templates",

  // Reports
  REPORTS: "/jewellery/reports",
  REPORTS_PENDING_VERIFICATIONS: "/jewellery/reports/pending-verifications",
  REPORTS_OVERDUES: "/jewellery/reports/overdues",
  REPORTS_MATURITIES: "/jewellery/reports/maturities",
  REPORTS_REDEMPTIONS: "/jewellery/reports/redemptions",

  // Cancellations
  CANCELLATIONS_ROOT: "/jewellery/cancellations",
  CANCEL_PLAN: "/jewellery/cancellations/:planId/cancel",
  CANCELLATION_STATUS: "/jewellery/cancellations/:planId/status",
  PENDING_CANCELLATIONS: "/jewellery/cancellations/pending",

  // Refunds
  REFUNDS: "/jewellery/cancellations/refunds",
  REFUND_DETAILS: "/jewellery/cancellations/refunds/:refundId",

  // Collections
  COLLECTIONS: "/jewellery/cancellations/collections",
  COLLECTION_DETAILS: "/jewellery/cancellations/collections/:collectionId",

  // Statistics
  CANCELLATION_STATISTICS: "/jewellery/cancellations/statistics",
};

export const CANCELLATION_API_ENDPOINTS = {
  // ==================== ELIGIBILITY & QUOTES ====================
  CHECK_CANCELLATION_ELIGIBILITY: "/cancellations/:planId/eligibility",
  GET_CANCELLATION_QUOTE: "/cancellations/:planId/quote",

  // ==================== CANCELLATION PROCESSING ====================
  PROCESS_CANCELLATION: "/cancellations/:planId/process",
  GET_CANCELLATION_STATUS: "/cancellations/:planId/status",

  // ==================== APPROVAL WORKFLOW ====================
  GET_PENDING_CANCELLATIONS: "/cancellations/requests/pending",
  APPROVE_CANCELLATION_REQUEST:
    "/cancellations/requests/:cancellationRequestId/approve",

  // ==================== REFUNDS ====================
  LIST_REFUNDS: "/cancellations/refunds",
  GET_REFUND_STATUS: "/cancellations/refunds/:refundRequestId",
  UPDATE_REFUND_STATUS: "/cancellations/refunds/:refundRequestId",
  APPROVE_REFUND: "/cancellations/refunds/:refundRequestId/approve",
  COMPLETE_REFUND: "/cancellations/refunds/:refundRequestId/complete",

  // ==================== COLLECTIONS ====================
  LIST_COLLECTIONS: "/cancellations/collections",
  GET_COLLECTION_STATUS: "/cancellations/collections/:collectionRequestId",
  UPDATE_COLLECTION_STATUS: "/cancellations/collections/:collectionRequestId",
  RECORD_COLLECTION_PAYMENT:
    "/cancellations/collections/:collectionRequestId/payments",
  WAIVE_COLLECTION: "/cancellations/collections/:collectionRequestId/waive",
  RESOLVE_COLLECTION: "/cancellations/collections/:collectionRequestId/resolve",

  // ==================== STATISTICS ====================
  GET_CANCELLATION_STATS: "/cancellations/stats",
  GET_REFUND_STATS: "/cancellations/stats/refunds",
  GET_COLLECTION_STATS: "/cancellations/stats/collections",
};

export const PLAN_API_ENDPOINTS = {
  // ==================== PLAN MANAGEMENT ====================
  CREATE_PLAN: "/plans",
  GET_ALL_PLANS: "/plans",
  GET_PLAN_BY_ID: "/plans/:id",
  GET_CUSTOMER_PLANS: "/plans/customer/:userId",

  // ==================== PLAN DETAILS ====================
  GET_PLAN_SCHEDULE: "/plans/:planId/schedule",
  GET_PLAN_LEDGER: "/plans/:planId/ledger",

  // ==================== PAYMENT MANAGEMENT ====================
  RECORD_PLAN_PAYMENT: "/plans/:planId/payments",

  // ==================== QUOTE GENERATION ====================
  CREATE_QUOTE: "/plans/:planId/quotes",

  // ==================== PAUSE FUNCTIONALITY ====================
  PAUSE_PLAN: "/plans/:planId/pause",
  RESUME_PLAN: "/plans/:planId/resume",
  GET_PAUSE_HISTORY: "/plans/:planId/pause-history",
  CHECK_PAUSE_ELIGIBILITY: "/plans/:planId/pause-eligibility",
  APPROVE_PAUSE: "/plans/pause/:pauseId/approve",
  REJECT_PAUSE: "/plans/pause/:pauseId/reject",
  GET_PENDING_PAUSE_REQUESTS: "/plans/pause/pending",
};

export const JEWELLERY_API_ENDPOINTS = {
  // ========== PAYMENTS ==========
  CREATE_PAYMENT: "/payments",
  GET_ALL_PAYMENTS: "/payments",
  GET_PENDING_PAYMENTS: "/payments/pending",
  GET_PAYMENT_BY_ID: "/payments/:id",
  VERIFY_PAYMENT: "/payments/:id/verify",
  REJECT_PAYMENT: "/payments/:id/reject",
  GET_PLAN_PAYMENTS: "/payments/plan/:planId",
  GET_CUSTOMER_PAYMENTS: "/payments/customer/:customerId",

  // ========== TEMPLATES ==========
  CREATE_TEMPLATE: "/templates",
  GET_TEMPLATES: "/templates",
  GET_TEMPLATE: "/templates/:id",
  UPDATE_TEMPLATE: "/templates/:id",
  DELETE_TEMPLATE: "/templates/:id",

  // ========== QUOTES ==========
  CHECK_BALANCE: "/quote/balance/:planId",
  CREATE_BALANCE_QUOTE: "/quote/create-balance",
  GET_QUOTE: "/quote/:id",
  VALIDATE_QUOTE: "/quote/:id/validate",
  GET_PLAN_QUOTES: "/quote/plan/:planId",

  // ========== REDEMPTIONS ==========
  CREATE_REDEMPTION: "/redemptions",
  GET_ALL_REDEMPTIONS: "/redemptions",
  GET_REDEMPTION_BY_ID: "/redemptions/:id",
  GET_CUSTOMER_REDEMPTIONS: "/redemptions/customer/:userId",
  APPROVE_REDEMPTION: "/redemptions/:id/approve",
  REJECT_REDEMPTION: `/redemptions/:id/reject`,
  CANCEL_REDEMPTION: "/redemptions/:id/cancel",

  // ========== CANCELLATIONS ==========
  CHECK_CANCELLATION_ELIGIBILITY_V2: "/cancellations/:planId/eligibility",
  GET_CANCELLATION_QUOTE_V2: "/cancellations/:planId/quote",
  PROCESS_CANCELLATION: "/cancellations/:planId/process",
  GET_CANCELLATION_STATUS_V2: "/cancellations/:planId/status",
  APPROVE_CANCELLATION_REQUEST:
    "/cancellations/requests/:cancellationRequestId/approve",
  GET_PENDING_CANCELLATIONS: "/cancellations/requests/pending",

  // Refunds
  GET_REFUND_STATUS: "/cancellations/refunds/:refundRequestId",
  UPDATE_REFUND_STATUS: "/cancellations/refunds/:refundRequestId",

  // Collections
  GET_COLLECTION_STATUS: "/cancellations/collections/:collectionRequestId",
  RECORD_COLLECTION_PAYMENT:
    "/cancellations/collections/:collectionRequestId/payments",

  // ========== REPORTS ==========
  DAILY_COLLECTIONS: "/reports/daily-collections",
  PENDING_VERIFICATIONS: "/reports/pending-verifications",
  OVERDUES: "/reports/overdues",
  MATURITIES: "/reports/maturities",
  REDEMPTIONS_REPORT: "/reports/redemptions",
  DASHBOARD_STATS: "/reports/dashboard",
  EXPORT_LEDGER: "/reports/export/ledger",
};

export const JEWELLERY_PERMISSIONS = {
  // Plan Management
  VIEW_PLANS: "PLANS_VIEW",
  CREATE_PLANS: "PLANS_CREATE",
  EDIT_PLANS: "PLANS_EDIT",
  CANCEL_PLANS: "PLANS_CANCEL",

  // Payment Management
  VIEW_PAYMENTS: "PAYMENTS_VIEW",
  RECORD_PAYMENTS: "PAYMENTS_RECORD",
  VERIFY_PAYMENTS: "PAYMENTS_VERIFY",

  // Redemption Management
  VIEW_REDEMPTIONS: "REDEMPTIONS_VIEW",
  CREATE_REDEMPTIONS: "REDEMPTIONS_CREATE",
  APPROVE_REDEMPTIONS: "REDEMPTIONS_APPROVE",

  // Admin Functions
  MANAGE_TEMPLATES: "TEMPLATES_MANAGE",
  MANAGE_RATES: "RATES_MANAGE",
  MANAGE_BRANCHES: "BRANCHES_MANAGE",
  VIEW_REPORTS: "REPORTS_VIEW",
  EXPORT_DATA: "DATA_EXPORT",

  // Override Permissions
  OVERRIDE_VARIANCE: "OVERRIDE_VARIANCE",
  OVERRIDE_BACKDATE: "OVERRIDE_BACKDATE",
  WAIVE_INSTALLMENTS: "WAIVE_INSTALLMENTS",

  MANAGE_CANCELLATIONS: "MANAGE_CANCELLATIONS",
};

// Plan Types
export const PLAN_TYPES = {
  VALUE_SAVINGS: "VALUE_SAVINGS",
  WEIGHT_SAVINGS: "WEIGHT_SAVINGS",
  PRICE_LOCK: "PRICE_LOCK",
};

// Plan Status
export const PLAN_STATUS = {
  ACTIVE: "ACTIVE",
  MATURED: "MATURED",
  REDEEMED: "REDEEMED",
  CANCELLED: "CANCELLED",
  DEFAULTED: "DEFAULTED",
};

// Payment Methods
export const PAYMENT_METHODS = {
  CASH: "CASH",
  UPI: "UPI",
  CARD: "CARD",
  BANK_TRANSFER: "BANK_TRANSFER",
  OTHER: "OTHER",
};

// Payment Status
export const PAYMENT_STATUS = {
  PENDING_REVIEW: "PENDING_REVIEW",
  VERIFIED: "VERIFIED",
  REJECTED: "REJECTED",
};

// Installment Status
export const INSTALLMENT_STATUS = {
  PENDING: "PENDING",
  PART_PAID: "PART_PAID",
  PAID: "PAID",
  MISSED: "MISSED",
  WAIVED: "WAIVED",
};

// Benefit Types
export const BENEFIT_TYPES = {
  FREE_INSTALLMENT: "FREE_INSTALLMENT",
  VA_DISCOUNT_CAP: "VA_DISCOUNT_CAP",
  MAKING_CHARGE_WAIVER: "MAKING_CHARGE_WAIVER",
  NONE: "NONE",
};

// Karats
export const KARATS = [14, 18, 22, 24];

// Default Policies
export const DEFAULT_POLICIES = {
  VARIANCE_LIMIT_PERCENT: 10,
  BACKDATE_LIMIT_DAYS: 2,
  GRACE_DAYS: 7,
  REDEMPTION_WINDOW_DAYS: 60,
  MIN_TENURE_MONTHS: 6,
  MAX_TENURE_MONTHS: 18,
  DEFAULT_MISSED_THRESHOLD: 3,
};

// Pause Reasons
export const PAUSE_REASONS = {
  FINANCIAL_TEMPORARY: "FINANCIAL_TEMPORARY",
  MEDICAL_EMERGENCY: "MEDICAL_EMERGENCY",
  JOB_LOSS: "JOB_LOSS",
  TRAVEL: "TRAVEL",
  FAMILY_EMERGENCY: "FAMILY_EMERGENCY",
  MATERNITY: "MATERNITY",
  EDUCATION: "EDUCATION",
  BUSINESS_LOSS: "BUSINESS_LOSS",
  NATURAL_DISASTER: "NATURAL_DISASTER",
  OTHER: "OTHER",
};

// Pause Status
export const PAUSE_STATUS = {
  ACTIVE: "ACTIVE",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
};
